import { render, staticRenderFns } from "./BaseSideMenuEntity.vue?vue&type=template&id=298a7845"
import script from "./BaseSideMenuEntity.vue?vue&type=script&lang=ts"
export * from "./BaseSideMenuEntity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports